import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { twMerge } from 'tailwind-merge';
import RadioLabel from './RadioLabel';
import { forwardRef, useRef } from 'react';
import { makeID } from '../../lib/utils';


const RadioGroup = forwardRef<
	React.ElementRef<typeof RadioGroupPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
	return (
		<RadioGroupPrimitive.Root
			ref={ref}
			className={twMerge('grid gap-2', className)}
			{...props}
		/>
	);
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = forwardRef<
	React.ElementRef<typeof RadioGroupPrimitive.Item>,
	React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & { label?: React.ReactNode }
>(({ className, label = 'Todos os aplicativos', id, ...props }, ref) => {
	const generatedId = useRef(makeID());
	const itemId = id ?? generatedId.current;

	return (
		<div className="flex flex-row items-center gap-2">
			<RadioGroupPrimitive.Item
				ref={ref}
				id={itemId}
				className={twMerge(
					'aspect-square size-4 rounded-full border-[1.5px] border-gray-300 text-primary focus:outline-none focus-visible:ring-1 focus-visible:ring-ring cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
					className
				)}
				{...props}
			>
				<RadioGroupPrimitive.Indicator className="flex items-center justify-center">
					<div className="bg-gray-900 size-[6px] rounded-full" />
				</RadioGroupPrimitive.Indicator>
			</RadioGroupPrimitive.Item>

			<RadioLabel controlsId={itemId}>
				{label}
			</RadioLabel>
		</div>
	);
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
